import { Bancontact } from "../../../Adyen/AdyenPaymentCard/Bancontact/modules/PaymentMethodsList/Payments/Adyen/AdyenPaymentCard/Bancontact/Bancontact.js";
import BancontactSummary from "../../../Adyen/AdyenPaymentCard/Bancontact/modules/PaymentMethodsList/Payments/Adyen/AdyenPaymentCard/Bancontact/BancontactSummary.js";
import { Creditcard } from "../../../Adyen/AdyenPaymentCard/Creditcard/modules/PaymentMethodsList/Payments/Adyen/AdyenPaymentCard/Creditcard/Creditcard.js";
import CreditcardSummary from "../../../Adyen/AdyenPaymentCard/Creditcard/modules/PaymentMethodsList/Payments/Adyen/AdyenPaymentCard/Creditcard/CreditcardSummary.js";
import { BancontactMobile } from "../../../Adyen/BancontactMobile/modules/PaymentMethodsList/Payments/Adyen/BancontactMobile/BancontactMobile.js";
import { Bizum } from "../../../Adyen/Bizum/modules/PaymentMethodsList/Payments/Adyen/Bizum/Bizum.js";
import { CashOnDelivery } from "../../../Adyen/CashOnDelivery/modules/PaymentMethodsList/Payments/Adyen/CashOnDelivery/CashOnDelivery.js";
import { Klarna } from "../../../Adyen/Klarna/modules/PaymentMethodsList/Payments/Adyen/Klarna/Klarna.js";
import { KlarnaAccount } from "../../../Adyen/KlarnaAccount/modules/PaymentMethodsList/Payments/Adyen/KlarnaAccount/KlarnaAccount.js";
import { KlarnaPayNow } from "../../../Adyen/KlarnaPayNow/modules/PaymentMethodsList/Payments/Adyen/KlarnaPayNow/KlarnaPayNow.js";
import { MobilePay } from "../../../Adyen/MobilePay/modules/PaymentMethodsList/Payments/Adyen/MobilePay/MobilePay.js";
import { Sepa } from "../../../Adyen/Sepa/modules/PaymentMethodsList/Payments/Adyen/Sepa/Sepa.js";
import { SepaSummary } from "../../../Adyen/Sepa/modules/PaymentMethodsList/Payments/Adyen/Sepa/SepaSummary.js";
import { Swish } from "../../../Adyen/Swish/modules/PaymentMethodsList/Payments/Adyen/Swish/Swish.js";
import { Twint } from "../../../Adyen/Twint/modules/PaymentMethodsList/Payments/Adyen/Twint/Twint.js";
import { Fake } from "../../../Fake/modules/PaymentMethodsList/Payments/Fake/Fake.js";
import { Invoice } from "../../../MfGroup/modules/PaymentMethodsList/Payments/MfGroup/Invoice.js";
import { Oney } from "../../../Adyen/Oney/modules/PaymentMethodsList/Payments/Adyen/Oney/Oney.js";
import { MbwaySummary } from "../../../Adyen/Mbway/modules/PaymentMethodsList/Payments/Adyen/Mbway/MbwaySummary.js";
import { Mbway } from "../../../Adyen/Mbway/modules/PaymentMethodsList/Payments/Adyen/Mbway/Mbway.js";
import { Multibanco } from "../../../Adyen/Multibanco/modules/PaymentMethodsList/Payments/Adyen/Multibanco/MultibancoContainer.js";
import { Multibanco as Multibanco$1 } from "../../../Adyen/Multibanco/component/modules/PaymentMethodsList/Payments/Adyen/Multibanco/component/Multibanco.js";
import { GooglePayRegularContainer } from "../../../Adyen/GooglePay/modules/PaymentMethodsList/Payments/Adyen/GooglePay/GooglePayRegularContainer.js";
import { ApplePay } from "../../../Adyen/ApplePay/modules/PaymentMethodsList/Payments/Adyen/ApplePay/ApplePay.js";
import { Paypal } from "../../../Adyen/Paypal/modules/PaymentMethodsList/Payments/Adyen/Paypal/Paypal.js";
import { Ideal } from "../../../Adyen/Ideal/modules/PaymentMethodsList/Payments/Adyen/Ideal/Ideal.js";
import { Paypal as Paypal$1 } from "../../../Paypal/modules/PaymentMethodsList/Payments/Paypal/Paypal.js";
import { PaymentServiceProvider, PaymentMethod } from "../../../../../../models/cart-payment-methods/models/cart-payment-methods/cart-payment-methods.js";
const P = PaymentServiceProvider;
const M = PaymentMethod;
const providers = {
  [P.FAKE]: {
    [M.FAKE]: {
      type: M.FAKE,
      provider: P.FAKE,
      form: Fake
    }
  },
  [P.MFGROUP]: {
    [M.INVOICE]: {
      type: M.INVOICE,
      provider: P.MFGROUP,
      form: Invoice
    }
  },
  [P.PAYPAL]: {
    [M.PAYPAL]: {
      type: M.PAYPAL,
      provider: P.PAYPAL,
      form: Paypal$1
    }
  },
  [P.ADYEN]: {
    [M.IDEAL]: {
      type: M.IDEAL,
      provider: P.ADYEN,
      form: Ideal
    },
    [M.BANCONTACT_CARD]: {
      type: M.BANCONTACT_CARD,
      provider: P.ADYEN,
      form: Bancontact,
      summary: BancontactSummary
    },
    [M.CREDITCARD]: {
      type: M.CREDITCARD,
      provider: P.ADYEN,
      form: Creditcard,
      summary: CreditcardSummary
    },
    [M.PAYPAL]: {
      type: M.PAYPAL,
      provider: P.ADYEN,
      form: Paypal
    },
    [M.APPLE_PAY]: {
      type: M.APPLE_PAY,
      provider: P.ADYEN,
      form: ApplePay
    },
    [M.GOOGLE_PAY]: {
      type: M.GOOGLE_PAY,
      provider: P.ADYEN,
      form: GooglePayRegularContainer
    },
    [M.MOBILE_PAY]: {
      type: M.MOBILE_PAY,
      provider: P.ADYEN,
      form: MobilePay
    },
    [M.KLARNA]: {
      type: M.KLARNA,
      provider: P.ADYEN,
      form: Klarna,
      addCartToPayment: true
    },
    [M.KLARNA_PAY_NOW]: {
      type: M.KLARNA_PAY_NOW,
      provider: P.ADYEN,
      form: KlarnaPayNow,
      addCartToPayment: true
    },
    [M.BIZUM]: {
      type: M.BIZUM,
      provider: P.ADYEN,
      form: Bizum
    },
    [M.KLARNA_ACCOUNT]: {
      type: M.KLARNA_ACCOUNT,
      provider: P.ADYEN,
      form: KlarnaAccount,
      addCartToPayment: true
    },
    [M.MULTIBANCO]: {
      type: M.MULTIBANCO,
      provider: P.ADYEN,
      form: Multibanco$1,
      summary: Multibanco
    },
    [M.MBWAY]: {
      type: M.MBWAY,
      provider: P.ADYEN,
      form: Mbway,
      summary: MbwaySummary
    },
    [M.SEPA_DIRECT_DEBIT]: {
      type: M.SEPA_DIRECT_DEBIT,
      provider: P.ADYEN,
      form: Sepa,
      summary: SepaSummary
    },
    [M.ONEY]: {
      type: M.ONEY,
      provider: P.ADYEN,
      form: Oney
    },
    [M.SWISH]: {
      type: M.SWISH,
      provider: P.ADYEN,
      form: Swish
    },
    [M.BANCONTACT_MOBILE]: {
      type: M.BANCONTACT_MOBILE,
      provider: P.ADYEN,
      form: BancontactMobile
    },
    [M.TWINT]: {
      type: M.TWINT,
      provider: P.ADYEN,
      form: Twint
    }
  },
  [P.CASH_ON_DELIVERY]: {
    [M.CASH_ON_DELIVERY]: {
      type: M.CASH_ON_DELIVERY,
      provider: P.CASH_ON_DELIVERY,
      form: CashOnDelivery,
      addCartToPayment: true
    }
  }
};
const getPaymentImplementation = (provider, paymentMethod) => {
  const providerMap = providers[provider];
  if (!providerMap) {
    return void 0;
  }
  return providerMap[paymentMethod];
};
const getPaymentMethodSettings = (provider, paymentMethod, paymentMethodsSettings) => {
  if (!paymentMethodsSettings) {
    return void 0;
  }
  const paymentMethods = paymentMethodsSettings[provider];
  if (!paymentMethods) {
    return void 0;
  }
  return paymentMethods[paymentMethod];
};
const paymentMethodWithForm = (paymentMethod) => {
  const paymentMethodsWithForm = [
    PaymentMethod.MBWAY,
    PaymentMethod.CREDITCARD,
    PaymentMethod.BANCONTACT_CARD,
    PaymentMethod.FAKE,
    PaymentMethod.ONEY,
    PaymentMethod.SEPA_DIRECT_DEBIT
  ];
  return paymentMethodsWithForm.includes(paymentMethod);
};
export {
  getPaymentImplementation,
  getPaymentMethodSettings,
  paymentMethodWithForm
};
//# sourceMappingURL=providers.js.map
